export default "__VITE_ASSET__Dpc$19zJ__"